import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import NodeOption from '../../../../../types/BotBuilder/NodeOption';
import styles from './styles';

interface DraggableNodeProps {
  nodeOption: NodeOption;
}

function DraggableNode({ nodeOption }: DraggableNodeProps): React.ReactElement {
  const handleDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    const { dataTransfer } = event;
    if (dataTransfer) {
      dataTransfer.setData('application/reactflow', nodeOption.type);
      dataTransfer.effectAllowed = 'move';
    }
  };

  return (
    <Card sx={styles.nodeCard} draggable onDragStart={handleDragStart}>
      <CardContent sx={styles.nodeCardContent}>
        <Box sx={styles.nodeIcon}>{nodeOption.icon}</Box>
        <Typography variant='body2' sx={styles.nodeLabel}>
          {nodeOption.label}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default DraggableNode;
